import localforage from 'localforage';
import type { QueueStorageAdapter } from './types.ts';

export class LocalforageQueueStorageAdapter implements QueueStorageAdapter {
  async getItem<T = unknown>(key: string): Promise<T | null> {
    if (typeof window === 'undefined') {
      return null;
    }
    return (await localforage.getItem<T>(key)) ?? null;
  }

  async setItem<T = unknown>(key: string, value: T): Promise<void> {
    if (typeof window === 'undefined') {
      return;
    }
    await localforage.setItem(key, value);
  }
}

export class MemoryQueueStorageAdapter implements QueueStorageAdapter {
  private store = new Map<string, unknown>();

  async getItem<T = unknown>(key: string): Promise<T | null> {
    const val = this.store.get(key);
    return (val as T) ?? null;
  }

  async setItem<T = unknown>(key: string, value: T): Promise<void> {
    this.store.set(key, value);
  }

  clear(): void {
    this.store.clear();
  }
}

export const defaultQueueStorageAdapter: QueueStorageAdapter =
  typeof window !== 'undefined'
    ? new LocalforageQueueStorageAdapter()
    : new MemoryQueueStorageAdapter();
